<template>
  <div>
    <h3 v-if="title" class="favorites-subtitle">{{ title }}</h3>
    <p v-if="!authors.length" class="empty-state">{{ emptyText }}</p>
    <ul v-else class="author-list">
      <li v-for="author in authors" :key="author.id" class="author-item">
        <router-link
          :to="{ name: 'author-tracks', params: { id: author.id } }"
          class="author-link"
        >
          <UserIdentity :user="author" size="md">
            {{ userDisplayName(author) }} ({{ author.public_tracks_count ?? 0 }})
          </UserIdentity>
        </router-link>
        <FavoriteButton
          label="Автор в избранное"
          :favorited="true"
          :disabled="removingId === author.id"
          @unfavorite="$emit('remove', author)"
        />
      </li>
    </ul>
  </div>
</template>

<script setup>
import FavoriteButton from './FavoriteButton.vue'
import UserIdentity from './UserIdentity.vue'
import { userDisplayName } from '../utils/userDisplay'

defineProps({
  authors: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: '',
  },
  emptyText: {
    type: String,
    default: 'Пока нет избранных авторов.',
  },
  removingId: {
    type: [Number, null],
    default: null,
  },
})

defineEmits(['remove'])
</script>

<style scoped>
.favorites-subtitle {
  margin: 0 0 0.75rem;
  font-size: 0.9375rem;
}

.author-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.author-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  padding: 0.75rem;
  background: #fff;
}

.author-link {
  flex: 1;
  min-width: 0;
  color: #2563eb;
  text-decoration: none;
}

.author-link:hover {
  text-decoration: underline;
}
</style>
